module.exports = __webpack_public_path__ + "static/media/Ela5.d052b9c6.webp";